import { View } from 'react-native'

import { styled } from '~/core/styled'

export const Container = styled(View, theme => {
  return {
    base: {
      maxHeight: 320,
      zIndex: 1,

      position: 'absolute',
    },
  }
})
